import mongodb from '../../assets/stacklogo/mongodb.svg';

export default function Mongodb(){
    return(
        <img src={mongodb} alt="" srcset="" />
    )
}